/**
 * Diese Komponente gibt eine Übersicht über die HelpPosts aus.
 */

import 'regenerator-runtime/runtime'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Box, Grid, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { HelpPost } from '@professocialApi/professocial-core-frontend-api'
import { Route, Switch, useHistory } from 'react-router-dom'
import EditorHelpPostCard from './EditorHelpPostCard'
import ButtonComponent from '@professocial/professocialFormComponents/FormComponents/ButtonComponent'

export interface Props {
  data?: HelpPost[]
  deleteHelpPost: (id: string) => void
  basePath?: string
}

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    padding: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
}))

const EditorHelpPostOverview: React.FC<Props> = (props) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const history = useHistory()
  const basePath = props.basePath || ''

  const [data, setData] = useState<HelpPost[]| undefined>(props.data)

  useEffect(() => { setData(props.data) }, [props])

  return (
    <Switch>
      <Route exact path='/editor/help'>
        <Grid container spacing={2} sx={{ px: 2, pb: 6, mt: 1 }}>
          <Grid item xs={12}>
            <Box className={classes.button}>
              <ButtonComponent onClick={() => history.push('/editor/help/create')} color='primary' variant='contained' disableElevation text={t('coreHelp:createHelpPost')} />
            </Box>
            <Grid container spacing={2} sx={{ px: 2, pb: 6, mt: 1 }}>
              {data && data.map((dataEntry, index) => (
                <Grid key={index} item xs={12} sm={6} md={4} lg={3} sx={{ display: 'flex' }}>
                  <EditorHelpPostCard
                    dataEntry={dataEntry}
                    key={index}
                    index={index}
                    deleteHelpPostSelected={(id) => props.deleteHelpPost(id)}
                    basePath={basePath}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Route>
    </Switch>
  )
}
export default EditorHelpPostOverview
